import { MenuPermission, Permission } from "@types";

export function getAppMenus(
  appCode: string,
  permissions: Permission[] = []
): MenuPermission[] {
  const app = permissions.find((permission) => permission.appCode === appCode);
  return app?.menus || [];
}
